import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { ROUTES } from '../config/routes.config';
import { peekQrLoginReturn } from '../utils/qrSession';

export const GuestGuard: React.FC = () => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (isAuthenticated) {
    // Honour a pending return path (e.g. a QR scan) instead of always going to
    // the dashboard — this guard can win the race against LoginPage's navigate.
    const from = (location.state as { from?: string } | null)?.from;
    return <Navigate to={from || peekQrLoginReturn() || ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
};

export default GuestGuard;
